// extracted by mini-css-extract-plugin
module.exports = {"page":"page__tciN8","page-header":"page-header__3PrmV"};